<template>
  <v-app>
    <v-navigation-drawer
      class="desktop"
      v-model="left"
      app
      fixed
      :permanent="showLeftDrawer"
      :expand-on-hover="mini"
      :mini-variant.sync="mini"
      mini-variant-width="60"
      width="220"
      v-if="isAuthenticated"
    >
      <NavigationDrawer side="left"></NavigationDrawer>
    </v-navigation-drawer>

    <v-app-bar app flat class="mobile" v-if="isAuthenticated">
      <v-img
        :src="require('./assets/images/logo.png')"
        max-width="64px"
        style="z-index: 1"
      ></v-img>
      <v-spacer></v-spacer>
      <div>
        <v-badge
          v-if="getRanking().length > 0 && getRanking() < 3"
          overlap
          :content="
            getRanking() == '0'
              ? '1'
              : getRanking() == '1'
              ? '2'
              : getRanking() == '2'
              ? '3'
              : ''
          "
          :color="
            getRanking() == '0'
              ? '#ffc121'
              : getRanking() == '1'
              ? '#bcc5cc'
              : getRanking() == '2'
              ? '#ab8626'
              : '#26ab5e'
          "
        >
          <v-avatar
            size="40"
            :class="
              getRanking() == '0'
                ? 'avatar-1st'
                : getRanking() == '1'
                ? 'avatar-2nd'
                : getRanking() == '2'
                ? 'avatar-3rd'
                : 'avatar'
            "
          >
            <v-img :src="avatar"></v-img>
          </v-avatar>
        </v-badge>
        <v-avatar
          v-else
          size="40"
          :class="
            getRanking() == '0'
              ? 'avatar-1st'
              : getRanking() == '1'
              ? 'avatar-2nd'
              : getRanking() == '2'
              ? 'avatar-3rd'
              : 'avatar'
          "
        >
          <v-img :src="avatar"></v-img>
        </v-avatar>
        <v-btn icon @click.stop="right = !right" style="margin-left: 8px">
          <v-icon x-large color="#26AB5E">$icon-nav</v-icon>
        </v-btn>
      </div>
    </v-app-bar>

    <!-- Sizes your content based upon application components -->
    <v-main>
      <!-- Provides the application the proper gutter -->
      <v-container fluid>
        <!-- If using vue-router -->
        <router-view></router-view>

        <v-snackbar v-model="updateExists" timeout="-1" color="primary">
          Existe uma nova versão!
          <template v-slot:action="{ attrs }">
            <v-btn text v-bind="attrs" @click="refreshApp"> Actualizar? </v-btn>
          </template>
        </v-snackbar>
      </v-container>
    </v-main>

    <v-navigation-drawer
      class="mobile"
      v-model="right"
      app
      fixed
      flat
      right
      :permanent="showRightDrawer"
      v-if="isAuthenticated"
    >
      <NavigationDrawer
        side="right"
        @close-nav-drawer="right = false"
      ></NavigationDrawer>
    </v-navigation-drawer>
  </v-app>
</template>

<style>
@font-face {
  font-family: "Gilroy-Bold";
  src: url("assets/fonts/Gilroy-Bold.ttf");
}
@font-face {
  font-family: "Gilroy-SemiBold";
  src: url("assets/fonts/Gilroy-SemiBold.ttf");
}
@font-face {
  font-family: "Gilroy-Medium";
  src: url("assets/fonts/Gilroy-Medium.ttf");
}
* {
  font-family: "Gilroy-SemiBold";
  letter-spacing: normal !important;
}
.v-application {
  background-color: #e8ecf0 !important;
}
.v-toolbar__content {
  width: 100%;
  padding-left: 24px !important;
}
.logo-list-item {
  padding-top: 32px !important;
}
.v-sheet.v-card {
  border-radius: 6px !important;
  box-shadow: 0px 0px 8px rgba(48, 67, 81, 0.08) !important;
  border: none;
}
.news-dialog .v-card {
  padding: 0 5vw;
  height: 100%;
  overflow: auto;
  background-color: #ebeff3;
  border-radius: 6px 0 0 6px !important;
}
.v-btn {
  font-family: Gilroy-SemiBold !important;
  letter-spacing: normal !important;
  text-transform: none;
  border-radius: 6px;
}
.v-btn--block {
  text-transform: none !important;
  border-radius: 6px !important;
  font-size: 14px !important;
  height: 40px !important;
  padding: 0 16px !important;
  letter-spacing: initial;
}
.avatar {
  /* border: 2px solid #ffc121; */
  border: 2px solid #26ab5e;
}
.avatar-1st {
  border: 2px solid #ffc121;
}
.avatar-2nd {
  border: 2px solid #bcc5cc;
}
.avatar-3rd {
  border: 2px solid #ab8626;
}
.logout-btn {
  color: #304351;
  font-family: Gilroy-Bold;
  position: relative;
  top: -40px;
}
.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.v-list .v-list-item {
  margin: 0 8px !important;
}
.v-list .v-list-item--active {
  color: #26ab5e !important;
}
.v-list .v-list-item::before {
  border-radius: 6px !important;
}
.v-list .v-list-item--active .v-list-item__title {
  color: #304351 !important;
  font-family: Gilroy-Bold;
}
.v-list-item__title {
  color: #9aabb8 !important;
  font-family: Gilroy-SemiBold;
}
.user-title {
  font-family: Gilroy-Bold;
  font-size: 16px !important;
  line-height: 24px !important;
  color: #304351 !important;
}
.user-subtitle {
  font-family: Gilroy-SemiBold;
  font-size: 11px !important;
  line-height: 16px !important;
  color: #bcc5cc !important;
}
#telegram.v-sheet.v-card {
  border-radius: 10px !important;
  text-align: center !important;
  display: block !important;
  padding-top: 48px;

  position: relative;
  top: -50px;
}
/* LOGIN - REGISTER */
button.v-carousel__controls__item {
  color: #d8e0e6 !important;
}
button.v-carousel__controls__item.v-item--active {
  color: #26ab5e !important;
}
button.v-carousel__controls__item.v-item--active:before {
  display: none;
}
.carousel .v-carousel__controls {
  bottom: 46px;
}
.carousel .v-carousel__controls__item {
  margin: 0 !important;
}
.carousel .v-carousel__controls__item .v-icon {
  opacity: 1;
  font-size: 12px !important;
}
.v-application .v-input .icon-circle-check {
  /* Make inputs icon always green and size 14px */
  color: #26ab5e !important;
}
.v-application .v-input .icon-circle-error {
  /* Make inputs icon always green and size 14px */
  color: #f83030 !important;
}
.v-input .v-icon {
  /* Force input icons to be size 14px */
  width: 14px !important;
  top: 3px;
}
i.v-icon.notranslate.mdi.mdi-menu-down.theme--light {
  top: 0 !important;
}
.prefix-select .v-input__slot {
  background: #f7f9fa !important;
}
.login-register-text .v-input__slot {
  background: #f7f9fa !important;
  border-radius: 6px !important;
}
.login-register-text input {
  font-family: Gilroy-Bold;
  font-size: 11px;
  line-height: 16px;
  color: #bcc5cc !important;
}
.input-success > .v-input__control > .v-input__slot {
  background: #e9f7ef !important;
  mix-blend-mode: normal;
}
.input-error > .v-input__control > .v-input__slot {
  background: #ffe5e5 !important;
  mix-blend-mode: normal;
}
.input-success input {
  color: #26ab5e !important;
}
.login-register-text .v-input__slot::before,
.login-register-text .v-input__slot::after {
  display: none !important;
}
/* Navigation bar telegram card */
#telegram .v-card__title {
  font-family: Gilroy-Bold;
  font-size: 14px !important;
  color: #6d818f;
  display: block;
}
#telegram .v-card__subtitle {
  font-family: Gilroy-SemiBold;
  font-size: 11px !important;
  color: #6d818f;
  line-height: 13px;
}
#telegram .v-card__text {
  font-family: Gilroy-SemiBold;
  font-size: 9px !important;
  color: #bcc5cc;
  line-height: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 0 16px !important;
}
/* #telegram .v-card__text svg {
  position: absolute;
  top: -1px;
  left: 36px;
} */
#telegram .v-card__actions {
  padding: 16px;
}
/** */
.v-badge__badge {
  height: 16px !important;
  min-width: 16px !important;
  font-size: 10px !important;
  padding: 4px 0 !important;
  font-family: Gilroy-Bold;
}
.component-title {
  font-family: Gilroy-Bold;
  font-size: 24px;
  line-height: 40px;
  color: #304351;
}
.card-label {
  font-family: Gilroy-Bold;
  font-size: 14px;
  line-height: 24px;
  color: #6d818f;
  margin-bottom: 16px;
}
.chips-row .v-chip--label {
  margin-right: 4px;
  margin-bottom: 4px;
  border-radius: 2px !important;
  font-family: Gilroy-Bold;
  font-size: 10px;
  line-height: 16px;
  letter-spacing: 0.5px;
  text-transform: capitalize;
  color: #ffffff !important;
  background-color: #d8e0e6 !important;
}
.market-chip {
  background-color: #d8e0e6 !important;
  border: 1px solid #9aabb8;
  border-radius: 4px !important;
  font-family: Gilroy-SemiBold;
  font-size: 12px !important;
  line-height: 16px;
  color: #9aabb8 !important;
  margin: 0 8px 8px 0;
}

.market-chip .v-chip__content {
  max-width: 87px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block;
  top: 4px;
  position: relative;
}
/** Select boxes */
/*.v-text-field.v-text-field--solo .v-input__control,
.v-menu__content .v-list-item {
  min-height: 32px !important;
  height: 32px;
}*/
.v-select:not(.v-select--is-multi).v-text-field--single-line
  .v-select__selections,
.v-menu__content .v-list-item__title {
  font-family: Gilroy-SemiBold;
  font-size: 12px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #9aabb8;
}
.v-select__selection--comma,
.v-menu__content .v-list-item--active .v-list-item__title {
  font-family: Gilroy-SemiBold;
  font-size: 12px;
  line-height: 20px;
  color: #26ab5e !important;
  top: 1px;
  position: relative;
}

/* .v-input--is-label-active .v-input__slot {
  background-color: #bee6cf !important;
} */
.Tipo .v-input__slot,
.Estado .v-input__slot,
.Filtrar .v-input__slot,
.Modalidade .v-input__slot,
.País .v-input__slot {
  background-color: rgb(216, 224, 230) !important;
}
.Tipo .v-select__selection--comma,
.Estado .v-select__selection--comma,
.Filtrar .v-select__selection--comma,
.Modalidade .v-select__selection--comma,
.País .v-select__selection--comma {
  color: #9aabb8 !important;
}
.v-btn__content {
  top: 1px;
}
.gray-button {
  border-radius: 6px;
}
.gray-button .v-btn__content {
  color: #9aabb8;
}
.green-btn {
  border-radius: 6px;
}
.green-btn .v-btn__content {
  color: #ffffff !important;
}
.delete-btn {
  background: #f83030;
  border-radius: 6px !important;
}
.delete-btn .v-btn__content {
  color: #ffffff;
}
.close-btn {
  background: #d8e0e6;
  color: #9aabb8;
  border-radius: 40px !important;
}
.regular-btn {
  font-family: Gilroy-SemiBold;
  font-size: 14px;
  line-height: 24px;
  color: #ffffff;
  width: 220px;
  border-radius: 6px;
}
/** PAGINATION */
.pagination {
  margin-top: 20px;
}
.pagination ul {
  display: flex;
  flex-direction: row;
}
.pagination ul li:first-child {
  order: 1;
}
.pagination ul li:last-child {
  order: 2;
}
.pagination nav {
  float: left;
}
.v-pagination__item,
.v-pagination__navigation {
  box-shadow: none !important;
  background: transparent !important;
  color: #9aabb8 !important;
  height: 40px !important;
  min-width: 40px !important;
}
.v-pagination__item--active,
.v-pagination__navigation,
.theme--light.v-pagination .v-pagination__item--active {
  background: #d8e0e6 !important;
}
/** TABLES */
.v-data-table__wrapper {
  border-radius: 6px;
}
.table-header,
.v-data-table-header,
.v-data-table-header th {
  background-color: #d8e0e6 !important;
  background: #d8e0e6 !important;
}
.table-header th,
.v-data-table-header th {
  font-weight: 400 !important;
  font-family: Gilroy-SemiBold;
  font-size: 11px !important;
  line-height: 14px;
  color: #9aabb8 !important;
  padding: 0 8px !important;
  border-bottom: none !important;
}
.backoffice-table tr td {
  font-family: Gilroy-SemiBold;
  font-size: 14px;
  line-height: 24px;
  color: #304351;
  padding: 0 8px !important;
  height: 56px !important;
}
.backoffice-table tr th:first-child,
.backoffice-table tr td:first-child {
  padding-left: 24px !important;
}
.backoffice-table tr th:last-child,
.backoffice-table tr td:last-child {
  padding-right: 24px !important;
}
.v-dialog {
  border-radius: 6px !important;
}
.no-scroll {
  overflow: hidden !important;
}
.v-dialog .v-card__title {
  font-family: Gilroy-Bold;
  font-size: 16px !important;
  line-height: 24px;
  text-align: center;
  color: #1e2e3a;
  display: block !important;
  padding-top: 32px !important;
}
.v-dialog .v-card__text {
  font-family: Gilroy-SemiBold;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  color: #6d818f;
}
.news-dialog {
  margin-right: 0;
  width: 50%;
  height: 100%;
  max-height: 100% !important;
  position: absolute;
  right: 0;
  border-radius: 6px 0 0 6px !important;
}
/** TABS */
.v-tab {
  text-transform: capitalize;
  font-family: Gilroy-SemiBold;
  font-size: 14px;
  line-height: 24px;
  color: #9aabb8 !important;
}
.v-tab--active {
  color: #304351 !important;
}
.v-item-group,
.v-window__container,
.v-window-item {
  background: none !important;
}
/** BACKOFFICE */
.backoffice-table {
  background: none !important;
  border: none !important;
}
.backoffice-dialog .v-card__actions {
  padding: 0 !important;
}
.backoffice-table .v-data-table {
  background: none;
  box-shadow: none !important;
}
.backoffice-table .v-toolbar {
  background: transparent !important;
}
.backoffice-table .v-toolbar .v-toolbar__content {
  padding-right: 0 !important;
  padding-left: 0 !important;
}
.v-data-table .v-data-table__wrapper tbody {
  background-color: #ffffff;
}
.backoffice-table .v-select {
  max-width: 120px;
  margin-right: 8px;
}
.backoffice-table .search-feild {
  margin: 0 20px 8px 0;
  max-width: 280px;
}
.backoffice-table .search-feild .v-input__slot input {
  font-family: Gilroy-SemiBold;
  font-size: 12px;
  line-height: 20px;
  color: #bcc5cc;
}
.backoffice-table .search-feild .v-input__slot {
  background-color: #ffffff !important;
}
.backoffice-dialog .v-btn--tile {
  border-radius: 0 !important;
}
.backoffice-table .v-input--switch .v-input__slot {
  background-color: transparent !important;
}
.backoffice-table .v-input--selection-controls {
  margin-top: 0 !important;
}
.v-input--selection-controls__ripple {
  display: none;
}
.backoffice-dialog {
  overflow: hidden;
}
.backoffice-dialog .v-card {
  background-color: rgb(235, 239, 243);
}
.backoffice-dialog {
  overflow: hidden;
}
.backoffice-dialog .dialog-frame {
  padding: 0 120px 56px 120px;
  height: 800px;
  overflow-y: auto;
}
.backoffice-dialog .dialog-double-frame {
  padding: 0 60px 56px 60px;
}
.backoffice-dialog .dialog-title {
  font-family: Gilroy-Bold;
  font-size: 24px;
  line-height: 40px;
  color: #304351;
  margin-bottom: 24px;
}
.backoffice-dialog .dialog-label {
  font-family: Gilroy-SemiBold;
  font-size: 11px;
  line-height: 16px;
  color: #6d818f;
  margin-bottom: 4px;
}
.backoffice-dialog .dialog-text .v-input__slot {
  background-color: #d8e0e6 !important;
  border-radius: 4px !important;
}
.backoffice-dialog .dialog-text input {
  font-family: Gilroy-SemiBold;
  font-size: 14px;
  line-height: 24px;
  color: #6d818f;
}
.backoffice-dialog .dialog-text .v-input__slot::before,
.backoffice-dialog .dialog-text .v-input__slot::after {
  display: none !important;
}
.backoffice-dialog .v-select .v-input__slot {
  min-height: 40px;
}
.backoffice-dialog .v-input--is-label-active .v-input__slot {
  background-color: #d8e0e6 !important;
}
.backoffice-dialog .result-success .v-input__slot,
.result-success .outcome-row,
.result-success {
  background-color: #b0dbc6 !important;
}
.backoffice-dialog .result-fail .v-input__slot,
.result-fail .outcome-row,
.result-fail {
  background-color: #efb6b9 !important;
}
.backoffice-dialog .result-warning .v-input__slot,
.result-warning {
  background-color: rgb(255, 236, 188) !important;
}
.backoffice-dialog .v-input--is-label-active .v-select__selection--comma {
  color: #6d818f !important;
}
.backoffice-dialog .result-success .v-select__selection--comma,
.backoffice-dialog .result-success .v-icon,
.result-success .outcome-row div,
.result-success {
  color: #26ab5e !important;
}
.backoffice-dialog .result-fail .v-select__selection--comma,
.backoffice-dialog .result-fail .v-icon,
.result-fail .outcome-row div,
.result-fail {
  color: #f83030 !important;
}
.backoffice-dialog .result-warning .v-select__selection--comma,
.backoffice-dialog .result-warning .v-icon,
.result-warning {
  color: #ffc121 !important;
}
.result-success {
  border: 1px solid #26ab5e;
  border-color: #26ab5e !important;
}
.result-fail {
  border: 1px solid #f83030;
  border-color: #f83030 !important;
}
.result-warning {
  border: 1px solid #ffc121;
  border-color: #ffc121 !important;
}
.outcome-success .v-input__control > .v-input__slot {
  color: #26ab5e !important;
  background: #26ab5e;
}
.backoffice-dialog .v-input--switch .v-input__slot {
  background-color: transparent !important;
}
.backoffice-dialog .txt-remove-btn {
  position: relative;
  right: -24px;
  top: -4px;
}
.backoffice-dialog .prognostic-match .v-input__control {
  min-height: 80px !important;
  height: 80px;
}
.prognostic-match-menu .v-list-item {
  min-height: 64px !important;
  height: 64px;
  flex-wrap: wrap !important;
}
.prognostic-match-menu .v-list-item div:nth-child(1) {
  font-family: Gilroy-SemiBold;
  font-size: 12px;
  line-height: 14px;
  color: #9aabb8;
  margin-bottom: 8px;
}
.prognostic-match-menu .v-list-item div:nth-child(2) {
  font-family: Gilroy-Bold;
  font-size: 24px;
  color: #304351;
}
.dialog-switch {
  margin-top: 0 !important;
}
.dialog-switch .v-input__slot {
  background-color: transparent !important;
}
.dialog-switch .v-input__slot .v-label {
  font-family: Gilroy-SemiBold;
  font-size: 14px !important;
  line-height: 24px;
  color: #6d818f !important;
}
/** SETTINGS */
.settings-text .v-input__slot {
  background-color: #f7f9fa !important;
  border-radius: 6px !important;
  height: 48px;
}
.settings-text .v-input__slot input {
  font-family: Gilroy-SemiBold;
  font-size: 14px;
  line-height: 24px;
  color: #6d818f;
}
.disabled .v-input__slot input {
  color: #bcc5cc;
  background-color: #f7f9fa;
}
.settings-text .v-input__slot::before,
.settings-text .v-input__slot::after {
  display: none !important;
}
.settings-switch {
  margin-top: 0 !important;
}
.settings-switch .v-input__slot {
  background-color: transparent !important;
}
.settings-switch .v-input__slot .v-label {
  font-family: Gilroy-SemiBold;
  font-size: 14px !important;
  line-height: 24px;
  color: #6d818f !important;
}
/* MATCH DETAILS */
.team-logos {
  padding: 0;
}
.logos-container {
  position: absolute;
  right: 120px;
  padding-top: 36px;
}
.team-icon {
  margin: 0 !important;
  background-color: #ffffff;
  -webkit-box-shadow: 0 0 0 9px #f7f9fa;
  box-shadow: 0 0 0 9px #f7f9fa;
}
.team-icon >>> .v-image__image {
  background-size: 32px !important;
}
.green-label {
  font-size: 11px;
  line-height: 16px;
  padding-bottom: 0;
  font-family: Gilroy-Bold;
  color: #26ab5e !important;
  padding-right: 4px;
  margin-bottom: 8px !important;
}
.team-names {
  font-family: Gilroy-Bold;
  font-size: 32px;
  line-height: 40px;
  color: #304351 !important;
}
.match-date {
  font-family: Gilroy-Bold;
  font-size: 11px;
  line-height: 14px;
  color: #bcc5cc !important;
  margin-top: 8px !important;
}
.black-label {
  font-family: Gilroy-Bold;
  font-size: 16px;
  line-height: 24px;
  color: #304351;
}
/** PROGNOSTIC CARD */
.half-time {
  border: 1px solid #26ab5e !important;
}
.half-time-1 {
  border-top: none !important;
}
.v-card .card-container.not-bigometro:nth-child(2) {
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
}
.overflow-scroll {
  overflow-y: scroll;
}
/** Media queries */
.mobile {
  display: none !important;
  border-bottom: 1px solid #d8e0e6 !important;
}
.desktop {
  display: flex !important;
}
.v-main {
  padding-top: 16px !important;
  padding-right: 0 !important;
}
.v-navigation-drawer__border {
  display: none;
}
@media only screen and (min-width: 1264px) {
  .top-spacer {
    max-width: 1160px !important;
  }
}
@media only screen and (max-width: 768px) {
  .mobile {
    display: flex !important;
  }
  .desktop {
    display: none !important;
  }
  .top-spacer {
    padding-top: 48px !important;
  }
  .news-dialog {
    width: 100%;
  }
}
.prognostic-row .col {
  padding: 10px 10px 5px 10px;
}
.large-btn {
  flex: 0 0 204px !important;
  max-width: 204px !important;
}
@media only screen and (max-height: 1024px) {
  .backoffice-dialog .dialog-frame {
    height: 640px;
    overflow-y: auto;
  }
}
@media only screen and (max-height: 834px) {
  .backoffice-dialog .dialog-frame {
    padding: 0 32px 56px 32px;
    height: 480px;
    overflow-y: auto;
  }
}
@media only screen and (max-width: 480px) {
  .container .container {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .large-btn {
    min-width: 100%;
    padding-top: 4px !important;
  }
}
</style>

<script>
import Vue from "vue";
import NavigationDrawer from "@/components/NavigationDrawer.vue";

export default Vue.extend({
  name: "App",
  components: {
    NavigationDrawer,
  },
  data: () => ({
    // refresh variables
    refreshing: false,
    registration: null,
    updateExists: false,
    sidebarMenu: false,
    left: true,
    right: true,
    toggleMini: false,
    expandOnHover: true,
    showRightDrawer: false,
    alerts: 27,
    items: [
      { title: "Dashboard", href: "/", icon: "$icon-dashboard" },
      {
        title: "Prognósticos",
        href: "/prognosticos",
        icon: "$icon-prognosis",
      },
      {
        title: "Tiro Certeiro",
        href: "/tiro-certeiro",
        icon: "$icon-bullseye",
      },
      {
        title: "Bigómetro",
        href: "/bigometro",
        icon: "$icon-charts",
      },
      { title: "Notícias", href: "/noticias", icon: "$icon-news" },
    ],
  }),
  created() {
    // Listen for our custom event from the SW registration
    document.addEventListener("swUpdated", this.updateAvailable, {
      once: true,
    });

    // Prevent multiple refreshes
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (this.refreshing) return;
      this.refreshing = true;
      // Here the actual reload of the page occurs
      window.location.reload();
    });
  },
  methods: {
    // Store the SW registration so we can send it a message
    // We use `updateExists` to control whatever alert, toast, dialog, etc we want to use
    // To alert the user there is an update they need to refresh for
    updateAvailable(event) {
      this.registration = event.detail;
      this.updateExists = true;
    },

    // Called when the user accepts the update
    refreshApp() {
      this.updateExists = false;
      // Make sure we only send a 'skip waiting' message if the SW is waiting
      if (!this.registration || !this.registration.waiting) return;
      // send message to SW to skip the waiting and activate the new SW
      this.registration.waiting.postMessage({ type: "SKIP_WAITING" });
    },
    getRanking() {
      return this.$store.state.ranking;
    },
  },
  computed: {
    isAuthenticated() {
      return this.$store.state.authenticated;
    },
    showLeftDrawer() {
      return this.$vuetify.breakpoint.width > 768;
    },
    mini() {
      return this.$vuetify.breakpoint.width <= 1024;
    },
    avatar() {
      const photo = this.$store.state.user.photo;
      if (photo) {
        return photo;
      } else {
        return require("./assets/images/avatar.png");
      }
    },
  },
});
</script>
